module.exports = __webpack_public_path__ + "static/Menlo-Regular-9f94dc20bb2a09c15241d3a880b7ad01.ttf";